module.exports = __webpack_public_path__ + "static/media/Snehasish Bose.039d9bab.jpeg";